import React from "react";
import { Card, KeyValueList, ValueOrPlaceholder } from "@sscs/ui";
const CryptoCertificateCard = ({ certificate, link, }) => {
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { actions: link }, "Certificate details"),
        React.createElement(Card.Content, null, React.createElement(KeyValueList, { list: [
                {
                    Certificate: certificate.type,
                    "Valid from": (React.createElement(ValueOrPlaceholder, { value: certificate.valid_from
                            ? new Date(certificate.valid_from).toLocaleString()
                            : "" })),
                    "Valid to": (React.createElement(ValueOrPlaceholder, { value: certificate.valid_to
                            ? new Date(certificate.valid_to).toLocaleString()
                            : "" })),
                    Serial: React.createElement("code", null, certificate.serial_number),
                    Algorithm: certificate.algorithm,
                    Thumbprint: React.createElement("code", null, certificate.thumbprint),
                    Size: React.createElement(ValueOrPlaceholder, { value: certificate.size }),
                },
                "Subject",
                Object.fromEntries(certificate.subject),
                "Issuer",
                Object.fromEntries(certificate.issuer),
                "Extensions",
                certificate.extensions.reduce((acc, extension) => {
                    acc[extension.name] = (React.createElement(React.Fragment, null,
                        extension.value,
                        extension.is_critical && React.createElement("em", null, " (Critical)")));
                    return acc;
                }, {}),
            ] }))));
};
export default CryptoCertificateCard;
//# sourceMappingURL=CryptoCertificateCard.js.map